<template>
  <v-row dense class="monitor_component">
    <v-main>
      <v-container fluid grid-list-lg pa-0>
        <v-row dense row wrap>
          <v-col v-if="watchEnabled" :class="{ 'col-4': watchEnabled }">
            <v-sheet dark :height="heightLocationContainer">
              <LocationAutocomplete
                :initial="locationCode"
                @select="getLocation"
              ></LocationAutocomplete>
            </v-sheet>
          </v-col>
          <v-col v-if="watchEnabled" :class="{ 'col-4': watchEnabled }">
            <v-sheet
              :height="heightLocationContainer"
              dark
              :class="{ 'mt-1': !forecast }"
            >
              <div class="aoiTimePart text-center">
                {{ formattedStartDate }} UTC
              </div>
            </v-sheet>
          </v-col>
          <v-col v-if="watchEnabled" :class="{ 'col-4': watchEnabled }">
            <v-sheet dark :height="heightLocationContainer">
              <div class="close_container">
                <v-btn
                  v-if="showWatchEnabler && watchEnabled && !hasWatchOnly"
                  @click="toggleMonitor"
                  class="pull-right hyp-close-watch-btn"
                >
                  <span>Close</span>
                </v-btn>
                <v-btn outlined small @click="handleCopyClick" class="mr-2">
                  <v-icon class="mr-2 pull-right" size="15"
                    >fas fa-camera</v-icon
                  >
                  Screenshot
                </v-btn>
                <v-btn
                  outlined
                  small
                  v-if="isReportingFeatureUnlocked"
                  @click="handleGetCountryReport"
                >
                  <v-img
                    v-if="!isCountryReportLoading"
                    class="mr-2 pull-right"
                    width="1.5em"
                    height="1.5em"
                    src="@/assets/images/icons/menu_reporting_pane_white.png"
                  >
                  </v-img>
                  <Loader
                    v-if="isCountryReportLoading"
                    size="small"
                    color="white"
                    text=""
                    class="mr-2 pull-right"
                  ></Loader>
                  Country Report
                </v-btn>
              </div>
              <div class="clearfix"></div>
            </v-sheet>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col :class="leftColumnClass">
            <v-row dense row wrap>
              <v-col class="col-12">
                <DetailsSummary
                  v-if="!watchEnabled"
                  :show-watch-btn="showWatchEnabler"
                  :watch-enabled="watchEnabled"
                  :features="features"
                  :title="title"
                  :location-name="nameOfCountryCity"
                  @watch-enabled-click="toggleMonitor"
                  class="mb-3"
                ></DetailsSummary>

                <MonitorSummary
                  :type="monitorType"
                  :loading="pulseLoading"
                  :today-score="todayScore"
                  :pulse-score-max="pulseScoreMax"
                  :pulse-score-min="pulseScoreMin"
                  :pulse-score-yesterday="pulseScoreYesterday"
                  :forecast="forecast"
                  :is-history="!!startDateOverride"
                  :trigger="trigger"
                  :height="heightMonitorSummary"
                  :location="locationNameFormatted"
                  :show-watch-btn="showWatchEnabler"
                  :watch-enabled="watchEnabled"
                  :risk-ratings-country="riskRatingsCountry"
                  class="mb-3"
                  @finished="pulseLoading = false"
                  @watch-enabled-click="toggleMonitor"
                ></MonitorSummary>

                <v-sheet
                  dark
                  :height="
                    !isHotspots ? heightEventsListing : heightHotspotsListing
                  "
                  class="container-relative"
                >
                  <div style="display: hidden;">{{ location }}</div>

                  <ScribeLayout
                    v-if="
                      isHotspots ||
                      isControlRisksRatings ||
                      (locationInfo.code &&
                        locationInfo.type &&
                        locationInfo.name)
                    "
                    :location="locationInfo"
                    :score="todayScore"
                    :height="heightScribe"
                    :is-hotspots="isHotspots"
                    :is-control-risks-ratings="isControlRisksRatings"
                    :date-selected="dateEnd"
                  >
                    <template v-slot:events>
                      <div v-if="!isHotspots && !watchEnabled">
                        <ClusterTimeRangePicker
                          @selectionChanged="timeRangeChange"
                        />
                      </div>

                      <div>
                        <TopicsFilterBar
                          :showTotals="!!(source !== 'social')"
                          class="pt-2 pb-2 text-center pull-left"
                          :shown="eventTypesShown"
                          :selected="
                            hotspotTopics ? hotspotTopics : eventTypesSelected
                          "
                          :totals="eventTypesTotals"
                          @click="topicsFilterClick"
                        ></TopicsFilterBar>
                        <DetailsSourceSelector
                          v-if="
                            detailsSidebar.monitorType.indexOf('hotspotsCovid')
                          "
                          :is-monitor="true"
                          class="pull-right hyp-details-source-selector pa-0"
                          @click="sourceChanged"
                          :selected="source"
                        ></DetailsSourceSelector>
                        <div class="clearfix"></div>
                      </div>

                      <DetailsListCluster
                        v-if="eventsFeatures && eventsFeatures.length"
                        @get-data="getContentEvents"
                        :items="eventsFeatures"
                        :page="eventsPage"
                        :show-primary-topics="true"
                        :page-size="eventsPageSize"
                        :height-pixels="
                          !isHotspots
                            ? heightEventsListing
                            : heightHotspotsListing
                        "
                        :acceptable-primary-topics="eventTypesShownAndSelected"
                        :get-threshold-type-function="getThresholdTypeFunction"
                        :matomo-category="watchMatomoCategory"
                        class="px-0 mx-2 my-2"
                        @loaded="handleEventsLoaded"
                      ></DetailsListCluster>

                      <Loader
                        v-if="isEventsLoading && !eventsFeatures"
                        text=""
                        color="white"
                        class="mb-2"
                      ></Loader>
                      <div
                        v-if="
                          !isEventsLoading &&
                          (!eventsFeatures || !eventsFeatures.length) &&
                          (!isHotspots || source === 'social')
                        "
                        class="pa-3 hyp-no-data-text"
                      >
                        No articles for the filtered events
                        {{ locationNameFormatted }}
                      </div>

                      <div
                        v-if="
                          !isEventsLoading &&
                          (!eventsFeatures || !eventsFeatures.length) &&
                          isHotspots &&
                          source !== 'social'
                        "
                        class="pa-3 hyp-no-data-text"
                      >
                        The location of the Hotspot has changed. We just
                        refreshed the map so please look again for the updated
                        Hotspot location.
                      </div>

                      <DetailsSearchBar
                        v-show="eventsFeatures"
                        :type="detailsSearchBarType"
                      ></DetailsSearchBar>
                    </template>

                    <template v-slot:incidents>
                      <div>
                        <ClusterTimeRangePicker
                          @selectionChanged="timeRangeChange"
                        />
                      </div>
                      <IncidentsContent
                        :political-enabled="true"
                        :maritime-enabled="false"
                        :should-pull-data="true"
                        :time-range="[-1 * timeRange, 0]"
                        :country-iso="
                          riskRatingsCountry && riskRatingsCountry.iso3Code
                            ? riskRatingsCountry.iso3Code
                            : null
                        "
                        :county-code="countyCode"
                        :hide-minimized="true"
                        :hide-results-header="true"
                        :height="heightIncidentsContent"
                        :dark="true"
                        :should-map="false"
                        :refresh="incidentsRefresh"
                      ></IncidentsContent>
                    </template>
                  </ScribeLayout>
                </v-sheet>
              </v-col>
            </v-row>
          </v-col>

          <v-col v-if="watchEnabled" :class="centerColumnClass">
            <v-row dense row wrap>
              <v-col class="col-12" v-if="hasWebGL">
                <v-sheet
                  :height="heightMap"
                  dark
                  class="d-flex"
                  style="position: relative;"
                >
                  <v-btn
                    v-if="hotspotGeohash && hotspotTopics"
                    color="#607d8b"
                    dark
                    depressed
                    small
                    class="hyp-hotspot-map-clear-btn"
                    @click="handleHotspotMapClearClick"
                    >Clear</v-btn
                  >
                  <Map
                    v-if="mapOptions"
                    :id="mapId"
                    width="100%"
                    :height="heightMapContainer"
                    :options="mapOptions"
                    :show-base-layer-control="false"
                    :show-places="true"
                    @map-on-load="onMapLoadFnc"
                    @map-on-move-zoom-end="mapOnMoveEnd"
                    @map-on-idle="onMapIdleFnc"
                  ></Map>
                </v-sheet>
              </v-col>
              <LimitedDropdownSelector
                :selected-values="chartTypeSelection"
                :max-selected="2"
                :item-list="chartTypeOptions"
                :default-selected-items-ids="defaultChartTypeOptions"
                @change="handleChartSelection"
                class="pb-1"
              />
              <v-col
                class="col-12"
                v-for="chart in chartTypeSelection"
                :key="chart"
              >
                <v-sheet
                  v-if="chart === 'pulseLineGraph'"
                  dark
                  :height="heightPulseAndSentimentContainer"
                >
                  <div class="hyp-section-title application-heading">
                    PULSE HISTORY AND TRENDLINE
                  </div>
                  <Loader
                    v-if="
                      pulseChartLoading &&
                      (!histogramStability || !histogramStability.length)
                    "
                    text=""
                    color="white"
                    class="mb-2"
                  ></Loader>
                  <div
                    v-if="
                      !pulseChartLoading &&
                      (!histogramStability || !histogramStability.length)
                    "
                    class="pa-3 text-center hyp-no-data-text"
                  >
                    No 60 day daily Pulse {{ locationNameFormatted }}
                  </div>
                  <GridChart
                    type="stability"
                    :timeframe="60"
                    :compact="true"
                    :histogram="histogramStability"
                    :stats="statsStability"
                    :trend="trendValues"
                    :forecast="gridChartForecast"
                    :lockLinePieces="lockStabilityLinePieces"
                    :refresh="chartRefresh"
                    @click="gridChartClickHandler"
                    @finished="pulseChartLoading = false"
                  ></GridChart>
                </v-sheet>
                <SentimentChart
                  v-if="chart === 'sentimentHistogram'"
                  :histogram="sentimentHistogram"
                  :if-loading="sentimentLoading"
                  title="DAILY SENTIMENT"
                  :include-refresh-button="true"
                  :mark-line-interval="30"
                />
                <LineGraph
                  v-if="chart === 'emotionsLineGraph'"
                  title="Events AI Emotions"
                  :chart-data="collections.charts.emotionChartData"
                />
              </v-col>
            </v-row>
          </v-col>

          <v-col v-if="watchEnabled" :class="rightColumnClass">
            <v-row dense row wrap>
              <v-col cols="12">
                <v-sheet dark :height="heightHotspotsContainer">
                  <MonitorSectionTitle
                    title="hotspots"
                    :value="hotspotsCount"
                  ></MonitorSectionTitle>
                  <div
                    class="mx-2 my-2 hyp-hotspots-container"
                    :style="heightHotspotsContent"
                  >
                    <Loader
                      v-if="hotspotsLoading && (!hotspots || !hotspots.length)"
                      text=""
                      color="white"
                      class="mb-2"
                    ></Loader>
                    <div
                      v-if="
                        !hotspotsLoading &&
                        !hotspots.length &&
                        !startDateOverride
                      "
                      class="hyp-no-data-text text-center"
                    >
                      No Hotspots in last 24 hours {{ locationNameFormatted }}
                    </div>
                    <div
                      v-if="
                        !hotspotsLoading &&
                        !hotspots.length &&
                        startDateOverride
                      "
                      class="hyp-no-data-text text-center"
                    >
                      No Hotspots on {{ formattedStartDateOverride }}
                      {{ locationNameFormatted }}
                    </div>
                    <div v-if="!hotspotsLoading && hotspots.length">
                      <div
                        v-for="(item, index) in hotspots"
                        :key="index"
                        class="mb-3"
                      >
                        <div
                          class="pull-left mr-1"
                          @click="mapHotspotClickEvent(undefined, [item])"
                        >
                          <img
                            v-if="hotspotsImgSrc && !isHotspotSelected(item)"
                            class="mt-2 mx-2 hyp-icon-img hotspot-icon"
                            :src="hotspotsImgSrc"
                          />
                          <img
                            v-if="
                              hotspotsSelectedImgSrc && isHotspotSelected(item)
                            "
                            class="mt-2 mx-2 hyp-icon-img hotspot-icon"
                            :src="hotspotsSelectedImgSrc"
                          />
                        </div>
                        <div class="pull-left hyp-item-container">
                          <div>{{ item.properties.formatted.text }}</div>
                          <div class="hyp-date">
                            {{ item.properties.formatted.startTime }}
                          </div>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                    </div>
                  </div>
                </v-sheet>
              </v-col>
              <v-col cols="12">
                <MonitorTravel
                  :refresh="getTravel"
                  :dateStart="dateStartTravel"
                  :aoi="aoi"
                  v-on:sizeUpdated="heightTravelContainer = $event"
                  :startDateOverride="startDateOverride"
                  :locationNameFormatted="locationNameFormatted"
                ></MonitorTravel>
              </v-col>
              <v-col cols="12">
                <v-sheet
                  dark
                  :height="heightAlertsContainer"
                  id="alertedContentSheet"
                  class="container-relative"
                >
                  <MonitorSectionTitle
                    title="Alert Content"
                    :adjust-for-singular="false"
                    :value="alertsCount"
                  ></MonitorSectionTitle>

                  <div class="hyp-alert-content-filter-container mt-2">
                    <ContentAlertFilter
                      v-model="collections.alertFilters"
                      :is-independent="true"
                      default-label="Filter by Alert"
                      width="135"
                      :filter-counts="collections.alertFilterCounts"
                      @callback="contentFilterCallback"
                    ></ContentAlertFilter>
                    <ContentVeracityFilter
                      v-if="isVeracityFilterUnlocked"
                      v-model="collections.veracityFilters"
                      :is-independent="true"
                      default-label="Filter by Veracity"
                      width="160"
                      @callback="contentFilterCallback"
                    ></ContentVeracityFilter>
                  </div>

                  <DetailsListCluster
                    v-if="alertedContent && alertedContent.length"
                    @get-data="getAlertedContent"
                    :items="alertedContent"
                    :page="alertedContentPage"
                    :page-size="alertedContentPageSize"
                    :show-primary-topics="true"
                    :show-thumbs-down="true"
                    :show-thumbs-down-geo="true"
                    :height-pixels="heightAlertsContainer"
                    :get-threshold-type-function="getThresholdTypeFunction"
                    :matomo-category="alertMatomoCategory"
                    @loaded="alertsLoading = false"
                  ></DetailsListCluster>

                  <Loader
                    v-if="alertsLoading && !alertedContent"
                    text=""
                    color="white"
                    class="mb-2"
                  ></Loader>
                  <div
                    v-if="
                      !alertsLoading &&
                      (!alertedContent || !alertedContent.length)
                    "
                    class="pa-3 hyp-no-data-text text-center"
                  >
                    No articles for alerts {{ locationNameFormatted }}
                    <div v-if="alertedContentSearch">
                      <a @click="handleClearSearchAlerts">Clear Filter</a>
                    </div>
                  </div>

                  <span>
                    <DetailsSearchBar
                      v-show="alertedContent"
                      type="watch-alerts"
                      @submit-search="handleSubmitSearchAlerts"
                    ></DetailsSearchBar>
                  </span>
                </v-sheet>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-overlay :absolute="true" :value="screenShotting">
      <div class="copy-overlay-indicator">
        <v-icon size="45" color="white">fas fa-check</v-icon>
        <div><strong>Screenshot Captured</strong></div>
      </div>
    </v-overlay>
  </v-row>
</template>

<script>
import lodashOrderBy from "lodash/orderBy";
import lodashCloneDeep from "lodash/cloneDeep";
import lodashGet from "lodash/get";
import lodashHas from "lodash/has";
import lodashFind from "lodash/find";
import lodashDebounce from "lodash/debounce";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import html2canvas from "html2canvas";

dayjs.extend(utc);

import { mapGetters } from "vuex";

import {
  MODULE_PREFIX_MAP,
  MODULE_PREFIX_USER,
  MODULE_PREFIX_MONITOR,
  MODULE_PREFIX_HOME,
  MODULE_PREFIX_SEARCH,
  MODULE_PREFIX_ALERTS_CONTENT,
  MODULE_PREFIX_ALERTS,
  MODULE_PREFIX_HOTSPOTS,
} from "@/store";
import {
  GET_NOTIFIER,
  GET_MONITOR_STABILITY,
  GET_MONITOR_ENABLED,
  GET_SELECTOR_PANEL,
  SAVE_PREFERENCES,
  GET_AUTO_REFRESH_ENABLED,
  GET_HOTSPOTS_REFRESH_MAP,
} from "@/store/actions.type";
import { SET_MONITOR_STABILITY } from "@/store/mutations.type";
import { DETAIL_SIDEBAR_TYPES } from "@/common/constants/home";
import {
  DEFAULT_LAYERS,
  MAP_ICON_NAMES,
  MAIN_MAP_ID,
} from "@/common/constants/maps";
import { removeMapData } from "@/common/maps/features";
import { GRIDS_STABILITY_TYPES } from "@/common/constants/grids";
import { DEFAULT_COUNTRY_CODE } from "@/common/constants/home";
import { NOTIFIER_TYPES } from "@/common/constants/misc";
import {
  now,
  hoursAgo24,
  daysAgo30Utc,
  getTodayStartEndDate,
  getFormattedDate,
  getFormatted,
  isToday,
} from "@/common/date.utilities";
import {
  parseStringToObject,
  setInfiniteScrollState,
} from "@/common/basic.utilities";
import {
  getBoundsStringFromGeometrySWNE,
  getLocationByCode,
  getBboxFromFeatures,
  getGeohashFeature,
} from "@/common/maps/utilities";
import {
  getHotspots as getHotspotsFeatures,
  addToMap as addHotspotsToMap,
} from "@/services/grids/hotspots.service";
import {
  getHistograms,
  addToMap as addPulseToMap,
  addForecastToMap as addPulseForecastToMap,
  queryStabilityLayer,
  queryForecastStabilityLayer,
  formatStabilityTileFeatureProperties,
} from "@/services/grids/stability.service";
import {
  getTopicKey,
  findTopicAllFlatten,
  getPrimaryTopics,
} from "@/services/events/topics.service";
import { getCountryReport } from "@/services/reporting/reporting.service";
import { getArticles, getFilterCounts } from "@/services/search/wod.service";
import { SOCIAL_SOURCES } from "@/common/constants/wodSocialSources";
import { getContent as getContentAlerts } from "@/services/alerts/alerts.service";
import {
  getSentiment,
  getArticles as getRawNewsArticles,
} from "@/services/media/news.service";
import { getTweets as getRawTwitter } from "@/services/media/twitter.service";
import { hasWatchOnlyAccess } from "@/services/user/user.service";
import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";
import {
  getChartData,
  formatChartData,
} from "@/services/charts/charts.service";
import { getRiskRatings } from "@/services/controlRisks/risks.service";
import { LABELS } from "@/common/constants/labels";

const CHART_TYPES = [
  { id: "sentimentHistogram", name: "Daily Sentiment" },
  { id: "pulseLineGraph", name: "Pulse History and Trendline" },
];

const LOCKED_CHART_TYPES = [
  { id: "emotionsLineGraph", name: "Events AI Emotions" },
];
export default {
  name: "Monitor",
  components: {
    Map: () => import("@/components/map/Map"),
    LocationAutocomplete: () =>
      import("@/components/common/LocationAutocomplete"),
    MonitorSectionTitle: () =>
      import("@/components/monitor/MonitorSectionTitle"),
    MonitorSummary: () => import("@/components/monitor/MonitorSummary"),
    DetailsSummary: () => import("@/components/common/details/DetailsSummary"),
    DetailsListCluster: () =>
      import("@/components/common/details/DetailsListCluster"),
    GridChart: () => import("@/components/grids/GridChart"),
    SentimentChart: () => import("@/components/common/details/SentimentChart"),
    LimitedDropdownSelector: () =>
      import("@/components/common/LimitedDropdownSelector"),
    TopicsFilterBar: () => import("@/components/events/TopicsFilterBar"),
    DetailsSourceSelector: () =>
      import("@/components/common/details/DetailsSourceSelector"),
    DetailsSearchBar: () =>
      import("@/components/common/details/DetailsSearchBar"),
    Loader: () => import("@/components/common/Loader"),
    ClusterTimeRangePicker: () =>
      import("@/components/events/ClusterTimeRangePicker"),
    MonitorTravel: () => import("@/components/monitor/MonitorTravel"),
    ContentAlertFilter: () =>
      import("@/components/alerts/contentExplorer/ContentAlertFilter"),
    ScribeLayout: () => import("@/components/scribe/ScribeLayout"),
    ContentVeracityFilter: () =>
      import("@/components/alerts/contentExplorer/ContentVeracityFilter"),
    IncidentsContent: () =>
      import("@/components/controlRisks/incidents/IncidentsContent"),
    LineGraph: () => import("@/components/events/LineGraph"),
  },
  props: {
    initialize: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
    },
    code: {
      type: String,
    },
  },
  data: function () {
    const PRIMARY_TOPICS = getPrimaryTopics();
    const SORTED_TOPICS = lodashOrderBy(PRIMARY_TOPICS, ["order"], ["asc"]);
    let types = [];
    SORTED_TOPICS.forEach((topic) => {
      if (this.featureUnlocked(`event-${topic.type}`)) {
        types.push(topic.type);
      }
    });

    return {
      screenShotting: false,
      locCode: this.code || null,
      initialLoad: true,
      hasWatchOnly: hasWatchOnlyAccess(),
      hasWebGL: this.isAvailableWebGL(),
      mapId: "monitor-hidden",
      getContentEventsCalled: false,
      labels: LABELS,
      aoi: null,
      locationPrevious: null,
      mapLoaded: false,
      layerIdAoi: "monitoraoi",
      layerIdHotspots: "monitorhotspots",
      keywords: null,
      eventTypes: types,
      eventTypesSelected: lodashCloneDeep(types),
      initialEventTypeTotals: true,
      eventsLoading: false,
      eventsPage: 1,
      eventsPageSize: 50,
      eventsSearch: null,
      local: true,
      histogramStability: null,
      pulseLoading: false,
      pulseChartLoading: false,
      hotspotsLoading: false,
      alertsLoading: false,
      isCountryReportLoading: false,
      alertedContentPage: 1,
      alertedContentPageSize: 50,
      alertedContentSearch: null,
      sentimentLoading: false,
      chartTypeSelection: [],
      gridPadding: 16,
      appHeight: window.innerHeight,
      appWidth: window.innerWidth,
      heightLocationContainer: 50,
      heightForecastContainer: 50,
      heightPulseAndSentimentContainer: 260,
      heightEmotionContainer: 320,
      heightChartSelector: 60,
      refreshInterval: null,
      refreshTime: 60000 * 10,
      startDateOverride: null,
      endDateOverride: null,
      lockStabilityLinePieces: false,
      regionName: null,
      localSearchDetails: null,
      source: "news",
      timeRange: null,
      timeRangeDisplay: null,
      hotspotGeohash: null,
      hotspotTopics: null,
      hotspotSelectedId: "hotspot-selected",
      mostRecentReqTime: new Date(),
      newAlertedContentAvailable: false,
      getTravel: new Date().toISOString(),
      chartRefresh: null,
      chartSentimentRefresh: null,
      heightTravelContainer: null,
      lastTimestamp: null,
      idsPulled: [],
      riskRatingCountries: null,
      collections: {
        hotspots: null,
        alerts: null,
        alertedContent: null,
        alertedContentTotal: null,
        charts: {
          emotionChartData: {},
        },
        travel: null,
        stabilitySourceFromTile: null,
        forecastStabilitySourceFromTile: null,
        sentiment: null,
        eventsTotal: null,
        eventsTotals: null,
        eventsFeatures: null,
        alertFilters: null,
        veracityFilters: null,
        alertFilterCounts: null,
      },
      incidentsRefresh: null,
      watchMatomoCategory: EVENT_CATEGORIES.monitor,
      alertMatomoCategory: EVENT_CATEGORIES.alerts,
      chartTypeOptions: this.featureUnlocked("events-charts")
        ? [...CHART_TYPES, ...LOCKED_CHART_TYPES]
        : CHART_TYPES,
      defaultChartTypeOptions: ["pulseLineGraph", "sentimentHistogram"],
    };
  },

  created() {
    window.addEventListener("resize", this.handleResize);
  },
  async mounted() {
    if (
      lodashGet(this.detailsSidebar, "monitorType") === "stability" ||
      this.detailsSidebar.monitorType.indexOf(
        DETAIL_SIDEBAR_TYPES.controlRisksRatings
      ) > -1
    ) {
      this.timeRange = 7;
      this.timeRangeDisplay = "last 7 days";
    } else {
      this.timeRange = 1;
      this.timeRangeDisplay = "last 24 hours";
    }

    if (
      this.detailsSidebar.monitorType.indexOf(DETAIL_SIDEBAR_TYPES.hotspots) >
        -1 ||
      this.detailsSidebar.monitorType.indexOf(
        DETAIL_SIDEBAR_TYPES.controlRisksRatings
      ) > -1
    ) {
      if (this.detailsSidebar.monitorType === "hotspotsCovid") {
        this.eventTypesSelected = [];
        this.eventTypesSelected.push("covid19");
      }
      this.$set(this.collections, "eventsFeatures", null);
      this.getContentEvents(null, null, true);
    }

    if (this.hasWebGL) {
      this.getStabilitySourceFromTile();
      this.getForecastStabilitySourceFromTile();
      this.getStability();
    }

    if (this.isStandalone) {
      const PARAMS = {
        stabilityType: this.type,
        code: this.locCode,
      };
      this.initializeMonitor();
      this.getLocation(PARAMS, true);
    }
    if (this.detailsSidebar.openMonitor) {
      this.locCode = this.detailsSidebar.code || DEFAULT_COUNTRY_CODE;
      const PARAMS = {
        stabilityType: this.detailsSidebar.stabilityType,
        code: this.locCode,
      };
      this.initializeMonitor();
      this.$store.dispatch(MODULE_PREFIX_MONITOR + GET_MONITOR_ENABLED, true);
      await this.getLocation(PARAMS, true);
    }
    this.riskRatingCountries = await getRiskRatings({});
  },
  computed: {
    ...mapGetters({
      maps: MODULE_PREFIX_MAP + "maps",
      userPreferences: MODULE_PREFIX_USER + "preferences",
      stability: MODULE_PREFIX_MONITOR + "stability",
      enabled: MODULE_PREFIX_MONITOR + "enabled",
      detailsSidebar: MODULE_PREFIX_HOME + "detailsSidebar",
      searchDetails: MODULE_PREFIX_SEARCH + "searchDetails",
      searchType: MODULE_PREFIX_SEARCH + "type",
      searchLoading: MODULE_PREFIX_SEARCH + "loading",
      selectorPanel: MODULE_PREFIX_HOME + "selectorPanel",
      notifier: MODULE_PREFIX_HOME + "notifier",
      firebaseEnabled: MODULE_PREFIX_HOME + "firebaseEnabled",
      alertPushTimestamp: MODULE_PREFIX_ALERTS_CONTENT + "alertPushTimestamp",
      alerts: MODULE_PREFIX_ALERTS + "alerts",
    }),
    eventsFeatures() {
      if (
        lodashGet(this.collections, "eventsFeatures") &&
        Array.isArray(this.collections.eventsFeatures)
      ) {
        return this.collections.eventsFeatures;
      }
      return null;
    },
    isStandalone() {
      if (this.type && this.locCode) {
        return true;
      }
      return null;
    },
    loader() {
      return this.detailsSidebar.loading;
    },
    watchEnabled() {
      if (this.isStandalone) {
        return true;
      }
      return this.enabled;
    },
    isEventsLoading() {
      if (this.eventsLoading) {
        return true;
      }
      if (this.searchLoading) {
        return true;
      }
      return false;
    },
    monitorType() {
      if (this.isStandalone) {
        return "stability";
      }
      if (lodashGet(this.detailsSidebar, "monitorType")) {
        return this.detailsSidebar.monitorType;
      }
      return null;
    },
    isHotspots() {
      if (
        lodashGet(this.detailsSidebar, "monitorType") &&
        this.detailsSidebar.monitorType.indexOf(DETAIL_SIDEBAR_TYPES.hotspots) >
          -1
      ) {
        return true;
      }
      return false;
    },
    isControlRisksRatings() {
      if (
        lodashGet(this.detailsSidebar, "monitorType") &&
        this.detailsSidebar.monitorType.indexOf(
          DETAIL_SIDEBAR_TYPES.controlRisksRatings
        ) > -1 &&
        this.featureUnlocked("cr_risks")
      ) {
        return true;
      }
      return false;
    },
    riskRatingsCountry() {
      let rrCountry;
      if (lodashGet(this.detailsSidebar, "features[0]")) {
        rrCountry = this.detailsSidebar.features[0];
      }
      if (!rrCountry || !lodashGet(this.detailsSidebar, "features[1]")) {
        if (
          this.riskRatingCountries &&
          Array.isArray(this.riskRatingCountries)
        ) {
          const countryISO2 = lodashGet(this.aoi, "properties.code")
            ? this.aoi.properties.code
            : lodashGet(this.detailsSidebar, "features[0].properties.i2")
            ? this.detailsSidebar.features[0].properties.i2
            : null;
          if (countryISO2) {
            const country = lodashFind(this.riskRatingCountries, [
              "iso2Code",
              countryISO2.toUpperCase(),
            ]);
            if (country) {
              rrCountry = country;
            }
          }
          if (
            lodashGet(this.detailsSidebar, "features[0].properties.Zone_ID")
          ) {
            // if user clicks on a country's zone then get the zone_id and find the country
            const len = this.riskRatingCountries.length;
            for (let i = 0; i < len; i++) {
              const cty = this.riskRatingCountries[i];
              if (cty && cty.riskZones && Array.isArray(cty.riskZones)) {
                for (let j = 0; j < cty.riskZones.length; j++) {
                  const zone = cty.riskZones[j];
                  if (
                    zone.code.toUpperCase() ===
                    this.detailsSidebar.features[0].properties.Zone_ID.toUpperCase()
                  ) {
                    rrCountry = cty;
                  }
                }
              }
            }
          }
        }
      }
      if (
        !lodashGet(rrCountry, "feature") &&
        lodashGet(this.detailsSidebar, "features[1]")
      ) {
        rrCountry.feature = this.detailsSidebar.features[1];
      }
      if (rrCountry) {
        return rrCountry;
      }
      return null;
    },
    countyCode() {
      if (
        lodashGet(this.aoi, "properties.stabilityType") &&
        lodashGet(this.aoi, "properties.code") &&
        this.aoi.properties.stabilityType === GRIDS_STABILITY_TYPES.county
      ) {
        return this.aoi.properties.code;
      }
      return null;
    },
    showWatchEnabler() {
      if (this.isStandalone) {
        return false;
      }
      return !this.isHotspots;
    },
    title() {
      if (this.isHotspots) {
        return this.labels.hotspots;
      }
      if (this.isControlRisksRatings) {
        return `${this.labels.cr_risk} & ${this.labels.stability}`;
      }
      return this.labels.pulse;
    },
    trigger() {
      if (this.isHotspots) {
        if (
          this.features &&
          Array.isArray(this.features) &&
          this.features.length &&
          lodashGet(this.features[0], "properties.topics")
        ) {
          const TS = Array.isArray(this.features[0].properties.topics)
            ? this.features[0].properties.topics
            : JSON.parse(this.features[0].properties.topics);
          let arr = [];
          TS.forEach((key) => {
            if (key === "covid19") {
              arr.push("covid19");
            } else {
              const topic = findTopicAllFlatten(key, true, false);
              if (
                topic &&
                (!topic.parentIds ||
                  (topic.parentIds &&
                    this.featureUnlocked(
                      `hotspot-subevent-${topic.apiName.replace("_", "-")}`
                    )))
              ) {
                const typeName = getTopicKey(topic.apiName);
                arr.push(typeName);
              }
            }
          });
          return arr;
        }
      }
      return null;
    },
    isHistoricalDate() {
      return this.dateEnd !== this.getTodaysDate;
    },
    dateStartTravel() {
      return daysAgo30Utc;
    },
    eventTypesShown() {
      if (this.trigger) {
        this.setEventTypesSelected(lodashCloneDeep(this.trigger));
        return this.trigger;
      } else {
        const PRIMARY_TOPICS = getPrimaryTopics();
        const SORTED_TOPICS = lodashOrderBy(PRIMARY_TOPICS, ["order"], ["asc"]);
        let types = [];
        SORTED_TOPICS.forEach((topic) => {
          if (
            this.featureUnlocked(`event-${topic.type}`) &&
            lodashGet(this.collections, "eventsTotals") &&
            this.collections.eventsTotals[topic.type] > 0
          ) {
            types.push(topic.type);
          }
        });
        types.push("all");
        return types;
      }
    },
    eventTypesShownAndSelected() {
      let shown = this.eventTypesShown;
      let selected = this.eventTypesSelected;
      let both = [];
      for (let shownIndex = 0; shownIndex < shown.length; shownIndex++) {
        for (
          let selectedIndex = 0;
          selectedIndex < selected.length;
          selectedIndex++
        ) {
          if (shown[shownIndex] === selected[selectedIndex]) {
            both.push(selected[selectedIndex]);
          }
        }
      }
      return both;
    },
    dateStart() {
      if (this.startDateOverride) {
        return this.startDateOverride.toISOString();
      }
      return hoursAgo24;
    },
    dateEnd() {
      if (this.endDateOverride) {
        return this.endDateOverride.toISOString();
      }
      return this.getTodaysDate;
    },
    getTodaysDate() {
      const TODAY = getTodayStartEndDate();
      return TODAY.end;
    },
    map() {
      if (this.maps[this.mapId]) {
        return this.maps[this.mapId];
      }
      return null;
    },
    mainMap() {
      if (this.maps[MAIN_MAP_ID]) {
        return this.maps[MAIN_MAP_ID];
      }
      return null;
    },
    baseLayer() {
      if (
        this.userPreferences &&
        this.userPreferences.map &&
        this.userPreferences.map["baseLayer_main_map"]
      ) {
        let baselayer = this.userPreferences.map["baseLayer_main_map"];
        // if the user stills has the old mapbox baselayers switch them to the esri baselayer
        if (
          this.userPreferences.map["baseLayer_main_map"].includes("mapbox://")
        ) {
          baselayer = DEFAULT_LAYERS.esri_night_time;
        }
        return baselayer;
      }
      return DEFAULT_LAYERS.esri_night_time;
    },
    mapOptions() {
      return {
        style: DEFAULT_LAYERS.esri_night_time,
        hideNavigationControls: false,
        hideScaleControls: true,
        attributionCompact: true,
      };
    },
    leftColumnClass() {
      if (this.watchEnabled) {
        return "col-4";
      }
      return "col-12";
    },
    centerColumnClass() {
      return "col-4";
    },
    rightColumnClass() {
      if (this.watchEnabled) {
        return "col-4";
      }
      return "";
    },
    sentimentHistogram() {
      if (
        lodashGet(this.collections, "sentiment") &&
        Array.isArray(this.collections.sentiment) &&
        this.collections.sentiment.length
      ) {
        let hasCount = false;
        this.collections.sentiment.forEach((item) => {
          if (lodashGet(item, "doc_count")) {
            hasCount = true;
          }
        });
        if (hasCount) {
          return this.collections.sentiment;
        }
      }
      return [];
    },
    trendValues() {
      if (lodashGet(this.stability, "Item.trend")) {
        return this.stability.Item.trend;
      }
      return null;
    },
    statsStability() {
      if (lodashGet(this.stability, "Item.stats")) {
        return this.stability.Item.stats;
      }
      return null;
    },
    weightedHistory() {
      if (lodashGet(this.stability, "Item.weighted_history")) {
        return this.stability.Item.weighted_history;
      }
      return null;
    },
    forecast() {
      let forecast = lodashGet(
        this.collections,
        "forecastStabilitySourceFromTile.properties.forecast"
      );
      if (forecast && Array.isArray(forecast) && forecast.length) {
        return forecast.slice(0, 7);
      }
      forecast = lodashGet(this.stability, "Item.forecast");
      if (forecast && Array.isArray(forecast) && forecast.length) {
        return forecast.slice(0, 7);
      }
      return null;
    },
    todayScore() {
      let result = null;

      if (this.startDateOverride && this.weightedHistory) {
        let today = dayjs.utc(this.getTodaysDate);
        let diff =
          today.startOf("day").diff(this.startDateOverride, "days") + 1;
        let index = this.weightedHistory.length - diff;
        if (this.weightedHistory[index]) {
          result = this.weightedHistory[index];
        }
      } else if (lodashGet(this.stability, "Item.count")) {
        result = this.stability.Item.count;
      }
      if (typeof result === "number") {
        // need to use Math.floor because the map color styling doesn't round at all so
        // 59.99 still will show yellow instead of green which is 60
        result = Math.floor(result);
      }
      return result;
    },
    pulseScoreMax() {
      if (
        typeof lodashGet(this.stability, "Item.stats.percentiles.very_high") ===
        "number"
      ) {
        return this.stability.Item.stats.percentiles.very_high;
      }
      return null;
    },
    pulseScoreMin() {
      if (
        typeof lodashGet(this.stability, "Item.stats.percentiles.very_low") ===
        "number"
      ) {
        return this.stability.Item.stats.percentiles.very_low;
      }
      return null;
    },
    pulseScoreYesterday() {
      let result = null;

      if (this.startDateOverride && this.weightedHistory) {
        let today = dayjs.utc(this.getTodaysDate);
        let diff =
          today.startOf("day").diff(this.startDateOverride, "days") + 1;
        let index = this.weightedHistory.length - diff;
        if (this.weightedHistory[index - 1]) {
          result = this.weightedHistory[index - 1];
        }
      } else if (
        this.weightedHistory &&
        this.weightedHistory[this.weightedHistory.length - 2]
      ) {
        result = this.weightedHistory[this.weightedHistory.length - 2];
      }
      if (typeof result === "number") {
        // need to use Math.floor because the map color styling doesn't round at all so
        // 59.99 still will show yellow instead of green which is 60
        result = Math.floor(result);
      }
      return result;
    },
    features() {
      if (
        lodashGet(this.detailsSidebar, "features") &&
        Array.isArray(this.detailsSidebar.features) &&
        this.detailsSidebar.features.length
      ) {
        let features = [];
        const LEN = this.detailsSidebar.features.length;
        for (let i = 0; i < LEN; i++) {
          let feature = this.detailsSidebar.features[i];
          if (!feature.hasOwnProperty("type")) {
            feature.type = "Feature";
          }
          features.push(feature);
        }
        return features;
      }
      return null;
    },
    location() {
      let feature;
      if (
        this.isControlRisksRatings &&
        lodashGet(this.riskRatingsCountry, "feature")
      ) {
        feature = this.riskRatingsCountry.feature;
        feature.properties.stabilityType = "country";
        feature.properties._id = feature.properties.iso2;
        feature.properties.code = feature.properties.iso2;
      }
      if (
        this.initialLoad &&
        !this.watchEnabled &&
        lodashGet(this.detailsSidebar, "monitorType") &&
        this.detailsSidebar.monitorType === DETAIL_SIDEBAR_TYPES.stability &&
        (lodashGet(this.detailsSidebar, "features[0].properties.code") ||
          lodashGet(this.detailsSidebar, "features[0].geometry.coordinates"))
      ) {
        feature = this.detailsSidebar.features[0];
      }
      if (feature) {
        let bounds = getBoundsStringFromGeometrySWNE(feature.geometry);
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        feature.properties.geometry = feature.geometry;
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        feature.properties.bounds = bounds;
        this.getLocation(feature.properties, true);
        this.setInitialLoad(false);
      }
      return null;
    },
    nameOfCountryCity() {
      if (
        lodashGet(this.aoi, "properties.stabilityType") &&
        this.aoi.properties.stabilityType !== GRIDS_STABILITY_TYPES.region
      ) {
        return this.locationName;
      }

      if (
        this.isControlRisksRatings &&
        lodashGet(this.riskRatingsCountry, "name")
      ) {
        return this.riskRatingsCountry.name;
      }

      if (
        this.isHotspots &&
        lodashGet(
          this.detailsSidebar,
          "features[0].properties.location_metadata"
        )
      ) {
        const PROPS = parseStringToObject(
          this.detailsSidebar.features[0].properties,
          "location_metadata"
        );
        if (PROPS) {
          if (
            lodashGet(PROPS, "location_metadata.method") &&
            PROPS.location_metadata.method.toLowerCase() === "cliff"
          ) {
            let locParts = [];
            if (lodashGet(PROPS, "location_metadata.city")) {
              locParts.push(PROPS.location_metadata.city);
            }
            if (lodashGet(PROPS, "location_metadata.state")) {
              locParts.push(PROPS.location_metadata.state);
            }
            if (lodashGet(PROPS, "location_metadata.country")) {
              locParts.push(PROPS.location_metadata.country);
            }
            if (locParts.length) {
              return locParts.join(", ");
            }
          }
        }
      }
      return null;
    },
    locationName() {
      let location = [];
      if (lodashGet(this.aoi, "properties.cityName")) {
        location.push(this.aoi.properties.cityName);
      }
      if (lodashGet(this.aoi, "properties.countyName")) {
        location.push(`${this.aoi.properties.countyName} County`);
      }
      if (lodashGet(this.aoi, "properties.stateAbbrev")) {
        location.push(this.aoi.properties.stateAbbrev);
      }
      if (lodashGet(this.aoi, "properties.countryName")) {
        location.push(this.aoi.properties.countryName);
      }
      if (location.length) {
        let txt = "";
        if (
          this.aoi.properties.stabilityType === GRIDS_STABILITY_TYPES.region
        ) {
          txt = "near";
        }
        return `${txt} ${location.join(", ")}`;
      }
      return null;
    },
    locationNameFormatted() {
      if (this.locationName) {
        if (this.locationName.indexOf("near ") > -1) {
          return this.locationName;
        }
        return `in ${this.locationName}`;
      }
      return null;
    },
    locationCode() {
      if (
        this.locCode &&
        lodashGet(this.detailsSidebar, "stabilityType") &&
        this.detailsSidebar.stabilityType !== GRIDS_STABILITY_TYPES.region &&
        this.detailsSidebar.stabilityType !== GRIDS_STABILITY_TYPES.county
      ) {
        return this.locCode;
      }
      if (lodashGet(this.aoi, "properties")) {
        if (
          this.aoi.properties.stabilityType !== GRIDS_STABILITY_TYPES.region &&
          this.aoi.properties.stabilityType !== GRIDS_STABILITY_TYPES.county &&
          lodashGet(this.aoi, "properties.code")
        ) {
          return this.aoi.properties.code;
        }
        if (
          this.aoi.properties.stabilityType === GRIDS_STABILITY_TYPES.region ||
          this.aoi.properties.stabilityType === GRIDS_STABILITY_TYPES.county
        ) {
          if (this.regionName) {
            return this.regionName;
          }

          let props = this.aoi.properties;
          if (props.cityName && props.countryName) {
            return "Near " + props.cityName + ", " + props.countryName;
          }
          if (!props.cityName && props.countryWithin) {
            return "In " + props.countryWithin;
          }
          if (props.cityName && !props.countryName) {
            return "Near " + props.cityName;
          }
          if (props.countyName && props.stateAbbrev && props.countryCode) {
            return `${props.countyName} County, ${props.stateAbbrev}`;
          }
        }
      }
      return null;
    },
    locationInfo() {
      let location = {
        code: null,
        codeIso3: null,
        name: null,
        type: null,
      };
      if (
        this.locCode &&
        lodashGet(this.detailsSidebar, "stabilityType") &&
        this.detailsSidebar.stabilityType !== GRIDS_STABILITY_TYPES.region
      ) {
        location.code = this.locCode;
        location.type = this.detailsSidebar.stabilityType;
        this.$set(location, "code", this.locCode);
        this.$set(location, "type", this.detailsSidebar.stabilityType);
      }
      if (
        this.isControlRisksRatings &&
        lodashGet(this.riskRatingsCountry, "iso2Code")
      ) {
        location.code = this.riskRatingsCountry.iso2Code;
        location.codeIso3 = this.riskRatingsCountry.iso3Code;
        location.name = this.riskRatingsCountry.name;
        location.type = "country";
      }
      if (lodashGet(this.aoi, "properties.code")) {
        this.$set(location, "code", this.aoi.properties.code);
      }
      if (lodashGet(this.aoi, "properties.codeIso3")) {
        this.$set(location, "codeIso3", this.aoi.properties.codeIso3);
      }
      if (lodashGet(this.aoi, "properties.stabilityType")) {
        this.$set(location, "type", this.aoi.properties.stabilityType);
      }
      let loc = [];
      if (lodashGet(this.aoi, "properties.cityName")) {
        loc.push(this.aoi.properties.cityName);
      }
      if (lodashGet(this.aoi, "properties.countyName")) {
        loc.push(`${this.aoi.properties.countyName} County`);
      }
      if (lodashGet(this.aoi, "properties.stateAbbrev")) {
        loc.push(this.aoi.properties.stateAbbrev);
      }
      if (lodashGet(this.aoi, "properties.countryName")) {
        loc.push(this.aoi.properties.countryName);
      }
      if (loc.length) {
        this.$set(location, "name", `${loc.join(", ")}`);
      }
      return location;
    },
    pulseType() {
      if (this.isStandalone) {
        return this.type;
      }
      let type = GRIDS_STABILITY_TYPES.region;
      if (lodashGet(this.aoi, "properties.stabilityType")) {
        if (
          this.aoi.properties.stabilityType === GRIDS_STABILITY_TYPES.country
        ) {
          type = GRIDS_STABILITY_TYPES.country;
        } else if (
          this.aoi.properties.stabilityType === GRIDS_STABILITY_TYPES.city
        ) {
          type = GRIDS_STABILITY_TYPES.city;
        }
      }
      return type;
    },
    hotspots() {
      if (
        lodashGet(this.collections, "hotspots") &&
        Array.isArray(this.collections.hotspots) &&
        this.collections.hotspots.length
      ) {
        return this.collections.hotspots;
      }
      return [];
    },
    hotspotsCount() {
      if (
        lodashGet(this.collections, "hotspots") &&
        Array.isArray(this.collections.hotspots) &&
        this.collections.hotspots.length
      ) {
        return this.collections.hotspots.length;
      }
      return 0;
    },
    hotspotsImgSrc() {
      return require(`@/assets/images/icons/hotspots_big.png`);
    },
    hotspotsSelectedImgSrc() {
      return require(`@/assets/images/icons/hotspots_big_selected.png`);
    },
    alertsCount() {
      if (lodashGet(this.collections, "alertedContentTotal")) {
        return this.collections.alertedContentTotal;
      }
      return 0;
    },
    alertImgSrc() {
      return require(`@/assets/images/icons/alerts_big.png`);
    },
    alertedContent() {
      if (
        lodashGet(this.collections, "alertedContent") &&
        Array.isArray(this.collections.alertedContent)
      ) {
        return this.collections.alertedContent;
      }
      return null;
    },
    eventTypesTotals() {
      if (lodashGet(this.collections, "eventsTotals")) {
        this.setContentEventsCalled(false);
        this.setInitialEventTypeTotals(false);
        return this.collections.eventsTotals;
      }
      return null;
    },
    heightHotspotsContent() {
      if (this.hotspotsCount) {
        let height = this.heightHotspotsContainer - 90;
        return {
          height: `${height}px`,
        };
      }
      return null;
    },
    heightHotspotsContainer() {
      let height = 100;
      if (this.hotspotsCount > 0) {
        height = 200;
      }
      return height;
    },
    heightHotspotsListing() {
      return this.appHeight - 250;
    },
    heightAlertsContent() {
      let height = this.heightAlertsContainer - 130;
      return {
        height: `${height}px`,
      };
    },
    heightAlertsContainer() {
      const MIN_HEIGHT = 205;
      const MULTIPLIER = this.isStandalone ? 8 : 12;
      const MISC = this.alertedContent && this.alertedContent.length ? 0 : 130;
      const PADDING = this.gridPadding * MULTIPLIER - MISC;
      let height =
        this.appHeight -
        PADDING -
        this.heightLocationContainer -
        this.heightTravelContainer -
        this.heightHotspotsContainer;
      return height > MIN_HEIGHT ? height : MIN_HEIGHT;
    },
    heightMap() {
      const MIN_HEIGHT = 190;
      const MULTIPLIER = this.isStandalone ? 6 : 5;
      const PADDING = this.gridPadding * MULTIPLIER;
      let height =
        this.appHeight -
        PADDING -
        this.heightLocationContainer -
        this.heightChartSelector -
        this.heightPulseAndSentimentContainer;
      if (this.chartTypeSelection.includes("emotionsLineGraph")) {
        height = height - this.heightEmotionContainer;
      } else {
        height = height - this.heightPulseAndSentimentContainer;
      }

      return height > MIN_HEIGHT ? height : MIN_HEIGHT;
    },
    heightMapContainer() {
      return `${this.heightMap}px`;
    },
    heightEventsContainer() {
      const MIN_HEIGHT = 300;
      const MULTIPLIER = this.isStandalone ? 7 : this.watchEnabled ? 5 : 8;
      const PADDING = this.gridPadding * MULTIPLIER;
      const MISC = this.featureUnlocked("cr_risks") ? 115 : 200;

      let height =
        this.appHeight -
        PADDING -
        MISC -
        this.heightMonitorSummary -
        this.heightLocationContainer;

      //covid won't have topic or source selector creating a gap below
      if (this.detailsSidebar.monitorType === "hotspotsCovid") {
        height += 50;
      }

      return height > MIN_HEIGHT ? height : MIN_HEIGHT;
    },
    heightMonitorSummary() {
      if (this.featureUnlocked("cr_risks")) {
        return this.watchEnabled ? 162 : 262;
      } else {
        return this.watchEnabled ? 142 : 162;
      }
    },
    heightScribe() {
      let adjustment = 100;
      if (this.watchEnabled) {
        adjustment = 70;
      }
      return this.heightEventsContainer + adjustment;
    },
    heightEventsListing() {
      let adjustment = 60;
      if (this.watchEnabled) {
        adjustment = 95;
      }
      return this.heightEventsContainer - adjustment;
    },
    heightIncidentsContent() {
      return this.watchEnabled ? "70vh" : "58vh";
    },
    formattedStartDateOverride() {
      return dayjs(this.startDateOverride).format("MMM D");
    },
    formattedStartDate() {
      const UTC_DATE = dayjs.utc(this.dateEnd).format("MM/DD/YYYY");
      return getFormattedDate(UTC_DATE);
    },
    detailsSearchBarType() {
      if (this.isStandalone) {
        return "watch";
      }
      return this.detailsSidebar.monitorType;
    },
    isVeracityFilterUnlocked() {
      return this.featureUnlocked("alert-content-veracity-filter");
    },
    gridChartForecast() {
      return this.forecast;
    },
    isReportingFeatureUnlocked() {
      return this.featureUnlocked("reporting");
    },
  },
  methods: {
    toggleMonitor(params) {
      if (params && params.regionName) {
        this.regionName = params.regionName;
      }
      const ENABLED = !this.watchEnabled;
      this.$store.dispatch(
        MODULE_PREFIX_MONITOR + GET_MONITOR_ENABLED,
        ENABLED
      );
      if (ENABLED) {
        this.changeUrl();
        this.initializeMonitor();
        this.getHistogramStability();
        this.getAlertedContent();
        this.getSentiment();
        this.getHotspots();
        this.getTravel = new Date().toISOString();
        this.getContentEvents(null, null, true);
      } else {
        this.startDateOverride = null;
        this.endDateOverride = null;
        this.histogramStability = null;
        this.collections = {
          hotspots: null,
          alerts: null,
          alertedContent: null,
          alertedContentTotal: null,
          charts: {
            emotionChartData: {},
          },
          travel: null,
          stabilitySourceFromTile: null,
          forecastStabilitySourceFromTile: null,
          sentiment: null,
          eventsTotal: null,
          eventsTotals: null,
          eventsFeatures: null,
        };
        this.getTravel = null;
        this.refresh();
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
        this.$store.dispatch(
          MODULE_PREFIX_HOME + GET_AUTO_REFRESH_ENABLED,
          true
        );
        this.$emit("close-parent");
      }
    },
    initializeMonitor() {
      this.mapLoaded = false;
      this.mapId = "monitor-" + Date.now().toString();

      this.refreshInterval = setInterval(() => {
        this.refresh();
        console.log("WATCH auto refreshed", new Date());
      }, this.refreshTime);

      this.$store.dispatch(
        MODULE_PREFIX_HOME + GET_AUTO_REFRESH_ENABLED,
        false
      );
    },
    savePrefs(stabilityType, locationId) {
      if (stabilityType && locationId) {
        let preferences = this.userPreferences;
        preferences.watch = preferences.watch || {};
        preferences.watch.code = locationId.toLowerCase();
        preferences.watch.type = stabilityType;
        this.$store.dispatch(
          MODULE_PREFIX_USER + SAVE_PREFERENCES,
          preferences
        );
      }
    },
    setInitialLoad(value) {
      this.initialLoad = value;
    },
    setContentEventsCalled(value) {
      this.getContentEventsCalled = value;
    },
    setInitialEventTypeTotals(value) {
      this.initialEventTypeTotals = value;
    },
    setEventTypesSelected(value) {
      this.eventTypesSelected = value;
    },
    async refresh() {
      this.getAlertedContent();
      this.getHistogramStability();
      this.getSentiment();
      this.getHotspots();
      this.getTravel = new Date().toISOString();
      this.$set(this.collections, "eventsFeatures", null);
      this.getContentEvents(null, null, false);
      this.incidentsRefresh = new Date().toISOString();
      this.mapAll();
      await this.getStability();
    },
    async getContentEvents(page, $state, init) {
      if (
        this.aoi ||
        this.detailsSidebar.monitorType.indexOf(DETAIL_SIDEBAR_TYPES.hotspots) >
          -1 ||
        this.detailsSidebar.monitorType.indexOf(
          DETAIL_SIDEBAR_TYPES.controlRisksRatings
        ) > -1
      ) {
        this.eventsLoading = true;
        page = !page ? 1 : page;
        const PAGE_OFFSET = (page - 1) * this.eventsPageSize;

        let params = {
          noGeometry: true,
          pageSize: this.eventsPageSize,
          pageOffset: PAGE_OFFSET,
          ignoreNext: true,
          timeBinSize: "1d",
          source: this.source ? this.source : null,
          eventType: "detected",
        };

        // if no events are selected then show raw news unless hotspots then dont show anything
        if (!this.getEventTypesToGrab().length) {
          // if hotspots then we're not showing anything if they turned off all events
          if (
            this.detailsSidebar.monitorType.indexOf(
              DETAIL_SIDEBAR_TYPES.hotspots
            ) > -1
          ) {
            this.eventsLoading = false;
            this.$set(this.collections, "eventsFeatures", null);
            return;
          }
        }

        params.forRawTwitter = this.source && this.source === "social";

        params.search = null;

        params = this.addGeoToParams(params);
        params = this.addStartEndToParams(params);

        if (this.eventsSearch) {
          params.search = this.eventsSearch;
        }
        if (this.localSearchDetails && this.searchDetails) {
          params.search = this.localSearchDetails;
        }

        if (this.eventTypesSelected) {
          params.type = this.getEventTypesToGrab().join();
        }
        if (this.hotspotTopics) {
          params.type = this.hotspotTopics.join();
        }

        params.forHotspots =
          this.detailsSidebar.monitorType.indexOf(
            DETAIL_SIDEBAR_TYPES.hotspots
          ) > -1 || !!this.hotspotTopics;

        const FUNC_REQ_TIME = new Date();
        this.mostRecentReqTime = FUNC_REQ_TIME;

        let result;
        try {
          if (params.hasOwnProperty("pageOffset") && params.pageOffset === 0) {
            this.$set(this.collections, "eventsFeatures", null);
          }
          let totals = await this.getTotals(params);
          totals = Object.entries(totals);
          let noTopicEvents = true;
          for (let i = 0; i < totals.length; i++) {
            if (totals[i][1] > 0 && params.type.indexOf(totals[i][0]) > -1) {
              noTopicEvents = false;
              break;
            }
          }

          if (noTopicEvents && params.type.indexOf("covid19") === -1) {
            if (params.forHotspots) {
              //Don't show raw news for hotspots
              this.eventsLoading = false;
              return;
            }
            params.forRawNews = params.forRawTwitter ? false : true;
            params.language = "all";
            params.fullDoc = true;
          }

          if (params.forRawNews) {
            result = await getRawNewsArticles(params);
          } else if (params.forRawTwitter) {
            params.fullDoc = true;
            result = await getRawTwitter(params, params.type);
          } else if (params.type || !params.forHotspots) {
            params.idsPulled = this.lastTimestamp ? this.idsPulled : [];
            result = await getArticles(params, this.lastTimestamp);
            await this.getChartData(params);
          }

          if (FUNC_REQ_TIME < this.mostRecentReqTime) {
            return null;
          }

          let features = [];
          let total = 0;

          if (result) {
            if (result.features) {
              features = result.features;
            }
            if (result.metadata && result.metadata.total) {
              total = result.metadata.total;
            }
          }

          if (PAGE_OFFSET === 0 && features.length < 1 && this.isHotspots) {
            this.$store.dispatch(
              MODULE_PREFIX_HOTSPOTS + GET_HOTSPOTS_REFRESH_MAP,
              true
            );
          }

          if (
            lodashGet(this.collections, "eventsFeatures") &&
            this.collections.eventsFeatures.length > 0 &&
            features
          ) {
            this.collections.eventsFeatures.concat(features);
            let allFeatures = this.collections.eventsFeatures.concat(features);
            this.$set(this.collections, "eventsFeatures", allFeatures);
          } else {
            this.$set(this.collections, "eventsFeatures", features);
          }

          if (!params.forRawNews) {
            this.$set(this.collections, "eventsTotal", total);
          }

          this.idsPulled = params.idsPulled;
          this.lastTimestamp = lodashGet(
            result,
            "features[0].properties.formatted.requestTimestamp"
          );
        } catch (error) {
          console.error("Error in getContentEvents: " + error);
        } finally {
          setInfiniteScrollState($state, result, "features");
          result = null;
        }

        this.eventsPage = page;
        this.getContentEventsCalled = true;
        if (init) {
          this.initialEventTypeTotals = true;
        }
      }
    },
    async getTotals(params) {
      params = JSON.parse(JSON.stringify(params));
      delete params.search;
      if (!params.forHotspots) {
        delete params.type;
      }
      if (params.source === "social") {
        params.source = SOCIAL_SOURCES.join(",");
      }

      let topicTotals = {};
      let result = await getFilterCounts(params);
      if (result && result.topicTotals) {
        const PRIMARY_TOPICS = getPrimaryTopics();
        PRIMARY_TOPICS.forEach((topic) => {
          topicTotals[topic.type] = 0;
          const key = getTopicKey(topic.type, true);
          if (result.topicTotals[key]) {
            topicTotals[topic.type] = result.topicTotals[key];
          }
        });
        this.$set(this.collections, "eventsTotals", topicTotals);
      }

      return topicTotals;
    },
    async sourceChanged(type) {
      this.source = type;
      this.$set(this.collections, "eventsFeatures", null);
      this.getContentEvents(null, null, false);
    },
    getStabilitySourceFromTile() {
      this.pulseLoading = true;
      let feature = null;
      if (this.watchEnabled && this.map && this.aoi) {
        const TYPE = this.aoi.properties.stabilityType;
        const FILTER_VALUE = lodashGet(this.aoi, "properties.code");
        if (FILTER_VALUE) {
          const FEATURES = queryStabilityLayer({
            map: this.map,
            type: TYPE,
            filterValue: FILTER_VALUE,
          });
          if (FEATURES && Array.isArray(FEATURES) && FEATURES.length) {
            feature = FEATURES[0];
          }
        }
      } else {
        // not showing watch so use the data from the tile after main map click
        const rawFeature = lodashGet(this.detailsSidebar, `features[0]`);
        feature = formatStabilityTileFeatureProperties(rawFeature);
      }
      this.$set(this.collections, "stabilitySourceFromTile", feature);
    },
    getForecastStabilitySourceFromTile() {
      if (!lodashGet(this.collections, "stabilitySourceFromTile")) {
        return;
      }

      let features = null;
      let filterValue = "";
      let type = "";

      if (
        lodashHas(this.collections, "stabilitySourceFromTile.properties.cic")
      ) {
        type = GRIDS_STABILITY_TYPES.city;
        filterValue = lodashGet(
          this.collections,
          "stabilitySourceFromTile.properties.cic"
        );
      } else if (
        lodashHas(this.collections, "stabilitySourceFromTile.properties.c")
      ) {
        type = GRIDS_STABILITY_TYPES.country;
        filterValue = lodashGet(
          this.collections,
          "stabilitySourceFromTile.properties.c"
        );
      } else if (
        lodashHas(this.collections, "stabilitySourceFromTile.properties.g")
      ) {
        type = GRIDS_STABILITY_TYPES.region;
        filterValue = lodashGet(
          this.collections,
          "stabilitySourceFromTile.properties.g"
        );
      }

      if (!filterValue) {
        return;
      }

      features = queryForecastStabilityLayer({
        map: this.map || this.mainMap,
        type: type,
        filterValue: filterValue,
      });

      if (!features || features.length === 0) {
        return;
      }

      this.$set(
        this.collections,
        "forecastStabilitySourceFromTile",
        features[0]
      );
    },
    async getStability() {
      let aoiCode;
      let type = GRIDS_STABILITY_TYPES.region;
      if (lodashGet(this.aoi, "properties.stabilityType")) {
        aoiCode = this.aoi.properties.code;
        type = this.aoi.properties.stabilityType;
      } else {
        if (
          this.detailsSidebar.monitorType.indexOf(
            DETAIL_SIDEBAR_TYPES.hotspots
          ) > -1 &&
          lodashGet(this.features, "[0].properties.geohash")
        ) {
          aoiCode = lodashGet(this.features[0], "properties.geohash");
        }
      }

      if (aoiCode) {
        let params = {
          //moving start back one day so that we have yesterday's score in the metadata
          start: dayjs(this.dateStart).add(-1, "days").toISOString(),
          end: this.dateEnd,
          local: this.local,
          stabilityType: type,
          includeForecast: true,
          aoi: aoiCode,
          syncTileScores: true,
        };

        this.$store.dispatch(
          MODULE_PREFIX_MONITOR + GET_MONITOR_STABILITY,
          params
        );
      }
    },
    async getHistogramStability() {
      let histograms = [];
      try {
        if (!this.aoi) {
          this.pulseChartLoading = false;
          return;
        }

        histograms = null;
        this.pulseChartLoading = true;
        this.histogramStability = [];

        let params = {
          stabilityType: this.aoi.properties.stabilityType,
          local: this.local,
          includeForecast: true,
          aoi: this.aoi.properties.code,
        };

        const START = dayjs(now).format("YYYY-MM-DD");
        const MINUS_DAYS = dayjs(START)
          .subtract(60, "days")
          .format("YYYY-MM-DD");

        params.end = getTodayStartEndDate().end;
        params.start = MINUS_DAYS + "T00:00:00.000Z";

        histograms = await getHistograms(params);

        if (histograms) {
          if (this.local && histograms.daily) {
            this.histogramStability = histograms.daily;
          } else if (!this.local && histograms.global) {
            this.histogramStability = histograms.global;
          }
          if (!this.startDateOverride) {
            if (
              this.histogramStability &&
              Array.isArray(this.histogramStability) &&
              this.histogramStability.length &&
              this.histogramStability[59] &&
              lodashGet(this.histogramStability[59], "count_sum.value") &&
              this.todayScore
            ) {
              this.histogramStability[59].count_sum.value = this.todayScore;
            }
          }
        }
      } catch (error) {
        this.pulseChartLoading = false;
        console.error("Unable to retrieve stability histograms", error);
      } finally {
        histograms = null;
      }
    },
    async getHotspots() {
      if (this.aoi) {
        this.hotspotsLoading = true;
        let params = {
          includeText: true,
          start: this.dateStart,
          end: this.dateEnd,
          search: this.searchDetails ? this.localSearchDetails : null,
          bounds:
            this.aoi.properties.stabilityType === GRIDS_STABILITY_TYPES.region
              ? this.aoi.properties.bounds
              : null,
          aoiId:
            this.aoi.properties.stabilityType !== GRIDS_STABILITY_TYPES.region
              ? this.aoi.properties.code
              : null,
        };

        const RESULT = await getHotspotsFeatures(params);
        const FEATURES = RESULT && RESULT.features ? RESULT.features : null;
        if (FEATURES) {
          for (let i = 0; i < FEATURES.length; i++) {
            if (
              lodashGet(FEATURES[i], "properties.formatted.topics[0]") &&
              lodashGet(FEATURES[i], "properties.formatted.text")
            ) {
              FEATURES[i].properties.formatted.text = FEATURES[
                i
              ].properties.formatted.text.replace("event", "Hotspot");
            }
          }
        }

        this.$set(this.collections, "hotspots", FEATURES);
        this.hotspotsLoading = false;
      }
    },
    handleSubmitSearchAlerts(search) {
      this.alertedContentSearch = search;
      this.getAlertedContent();
    },
    handleClearSearchAlerts() {
      this.alertedContentSearch = null;
      this.getAlertedContent();
    },
    handleEventsLoaded() {
      this.eventsLoading = false;
    },
    async getAlertedContent(page, state) {
      this.alertsLoading = true;

      page = !page ? 1 : page;
      const PAGE_OFFSET = (page - 1) * this.eventsPageSize;

      let params = {
        pageSize: this.eventsPageSize,
        pageOffset: PAGE_OFFSET,
        sortDirection: "desc",
        sortField: "@timestamp",
        geoOnly: true,
        alertStats: "include",
      };

      if (this.alertedContentSearch) {
        params.search = this.alertedContentSearch;
      }

      params.$state = state;

      params = this.addGeoToParams(params);
      params = this.addStartEndToParams(params);
      params = this.addAlertIdsFilter(params);
      params = this.addVeracityFilter(params);

      let result;
      try {
        if (params.hasOwnProperty("pageOffset") && params.pageOffset === 0) {
          this.$set(this.collections, "alertedContent", null);
        }

        result = await getContentAlerts(params);

        let content = [];
        let total = 0;

        if (result) {
          if (result.data) {
            let keys = Object.keys(result.data);
            keys.forEach((key) => {
              if (result.data[key].properties) {
                result.data[key].properties.formatted.name = this.getAlertName(
                  result.data[key].properties.sourceAlert
                );
              }
            });
            content = result.data;
          }
          if (result.total) {
            total = result.total;
          }
        }

        if (
          lodashGet(this.collections, "alertedContent") &&
          this.collections.alertedContent.length > 0 &&
          content
        ) {
          let allContent = this.collections.alertedContent.concat(content);
          this.$set(this.collections, "alertedContent", allContent);
        } else {
          this.$set(this.collections, "alertedContent", content);
        }

        this.$set(this.collections, "alertedContentTotal", total);
      } catch (error) {
        console.error("Error in getAlertedContent: " + error);
      } finally {
        setInfiniteScrollState(params.$state, result, "data");
        this.$set(this.collections, "alertFilterCounts", result.alertStats);
        result = null;
      }

      this.alertsLoading = false;
      this.alertedContentPage = page;
    },
    getUpdatedAlertedContent() {
      this.newAlertedContentAvailable = false;
      this.getAlertedContent(null, {});
    },
    attemptRefresh() {
      let alertedContentSheet = document.querySelector("#alertedContentSheet");
      if (alertedContentSheet && alertedContentSheet.scrollTop < 1) {
        this.getUpdatedAlertedContent();
      }
    },
    async checkForNewContent() {
      let params = {};
      params = this.addGeoToParams(params);
      params = this.addStartEndToParams(params);
      params.geoOnly = true;
      params.pageOffset = 0;
      params.pageSize = 2;
      params.sortDirection = "desc";
      params.sortField = "@timestamp";

      let mostRecentContentRes = await getContentAlerts(params);
      let potentialNewestTimestamp = lodashGet(
        mostRecentContentRes,
        "data[0].properties['@timestamp']"
      );
      let currentNewestTimestamp = lodashGet(
        this.contents,
        "data[0].properties['@timestamp']"
      );
      if (
        potentialNewestTimestamp &&
        currentNewestTimestamp &&
        potentialNewestTimestamp > currentNewestTimestamp
      ) {
        this.newAlertedContentAvailable = true;
      }
      if (potentialNewestTimestamp && !currentNewestTimestamp) {
        this.newAlertedContentAvailable = true;
      }
    },
    async getSentiment() {
      if (this.aoi || this.hotspotGeohash) {
        this.sentimentLoading = true;

        let params = {
          timeBinSize: "1d",
          verbosity: "none",
        };

        if (this.hotspotGeohash) {
          const FEATURE = getGeohashFeature(this.hotspotGeohash);
          let bounds = getBoundsStringFromGeometrySWNE(FEATURE.geometry);
          params.bounds = bounds;
        } else {
          if (
            this.aoi.properties.stabilityType === GRIDS_STABILITY_TYPES.region
          ) {
            params.bounds = this.aoi.properties.bounds;
          } else {
            params.aoiId = this.aoi.properties.code;
          }
        }

        const END = dayjs(now).format("YYYY-MM-DD");
        const MINUS_DAYS = dayjs(END).subtract(59, "days").format("YYYY-MM-DD");
        params.start = MINUS_DAYS;

        if (this.eventTypesSelected) {
          params.topics = this.getEventTypesToGrab().join();
        }
        if (this.hotspotTopics) {
          params.topics = this.hotspotTopics.join();
        }

        const RESULTS = await getSentiment(params);

        this.$set(this.collections, "sentiment", RESULTS);
        this.sentimentLoading = false;
      } else {
        console.log("Unable to get sentiment. No aoiId.");
      }
    },
    async getChartData(params) {
      const options = {
        emotionChartData: true,
        eventsSentimentData: false,
        sectorChartData: false,
        attackChartData: false,
        perpetratorChartData: false,
        vesselChartData: false,
        timeChartData: false,
      };
      const charts = formatChartData(await getChartData(params), options);

      this.$set(this.collections, "charts", charts);
    },
    topicsFilterClick(items, useUpdatedCounts) {
      this.$set(this.collections, "eventsFeatures", null);
      this.eventTypesSelected = lodashCloneDeep(items);
      this.getContentEvents(null, null, useUpdatedCounts);
      this.getSentiment();
    },
    changeUrl() {
      let url = "/";
      let countryCode;
      if (
        lodashGet(this.aoi, "properties.stabilityType") &&
        lodashGet(this.aoi, "properties.code")
      ) {
        countryCode = this.aoi.properties.code;
      }
      if (lodashGet(this.riskRatingsCountry, "iso2Code")) {
        countryCode = this.riskRatingsCountry.iso2Code;
      }
      if (countryCode) {
        url = `/watch/${countryCode}`;
        this.handlePageTrackerEvent(
          EVENT_CATEGORIES.monitor,
          EVENT_ACTIONS.opened,
          countryCode
        );
      }
      window.history.replaceState({}, "Seerist", url);
    },
    isSameAsPreviousLocation(location) {
      if (
        lodashGet(location, "stabilityType") &&
        this.locationPrevious &&
        location.stabilityType.toLowerCase() ===
          this.locationPrevious.stabilityType &&
        ((lodashGet(location, "_id") &&
          location._id.toLowerCase() === this.locationPrevious._id) ||
          (lodashGet(location, "code") &&
            location.code.toLowerCase() === this.locationPrevious._id))
      ) {
        return true;
      }
    },
    async getLocation(location, notFromDropdown) {
      this.idsPulled = [];
      this.lastTimestamp = null;

      if (!notFromDropdown) {
        this.clearSelectedHotspot();
      }

      // if already have this location then exit
      if (this.isSameAsPreviousLocation(location)) {
        return false;
      }

      if (location && location.stabilityType) {
        this.locationPrevious = {
          stabilityType: location.stabilityType.toLowerCase(),
          _id:
            !location._id && location.code
              ? location.code.toLowerCase()
              : location._id.toLowerCase(),
        };
      }

      if (
        !this.aoi ||
        this.aoi.properties.code.toLowerCase() !==
          location.code.toLowerCase() ||
        !notFromDropdown
      ) {
        if (!location.stabilityType) {
          console.error("Stability type not set for location");
        }
        if (!location._id && location.code) {
          location._id = location.code;
        }

        const { data } = await getLocationByCode(
          location.stabilityType,
          location._id
        );

        if (!data) {
          const message = `Unable to find location <br/>for code: <strong>${location._id}</strong>`;
          console.error(message);
          if (!this.notifier) {
            this.notifier = {};
          }
          this.notifier.visible = true;
          this.notifier.type = NOTIFIER_TYPES.error;
          this.notifier.message = message;
          this.notifier.seconds = 10;
          this.$store.dispatch(
            MODULE_PREFIX_HOME + GET_NOTIFIER,
            this.notifier
          );
          this.aoi = null;
          return;
        }

        if (lodashGet(data, "properties")) {
          let cityName,
            countyName,
            stateName,
            stateAbbrev,
            countryName,
            countryCode,
            countryCodeIso3;
          if (location.stabilityType === GRIDS_STABILITY_TYPES.city) {
            cityName = data.properties.displayName;
            countryName = data.properties.countryName;
            countryCode = data.properties.country.toLowerCase();
          }
          if (location.stabilityType === GRIDS_STABILITY_TYPES.county) {
            countyName = data.properties.displayName;
            stateName = data.properties.state;
            stateAbbrev = data.properties.stateAbbrev
              ? data.properties.stateAbbrev.toUpperCase()
              : null;
            countryName = data.properties.countryName;
            countryCode = data.properties.country.toLowerCase();
          } else if (location.stabilityType === GRIDS_STABILITY_TYPES.region) {
            cityName = data.properties.cityName;
            countryName = data.properties.countryName;
            countryCode = data.properties.countryCode.toLowerCase();
          } else {
            cityName = null;
            countryName = data.properties.displayName;
            countryCode = location._id.toLowerCase();
            countryCodeIso3 = data.properties.iso3;
          }

          this.aoi = {
            type: "Feature",
            geometry: data && data.geometry ? data.geometry : null,
            properties: {
              code: location._id.toLowerCase(),
              codeIso3: countryCodeIso3 ? countryCodeIso3 : null,
              stabilityType: location.stabilityType,
              cityName: cityName,
              countyName: countyName ? countyName : null,
              stateName: stateName ? stateName : null,
              stateAbbrev: stateAbbrev ? stateAbbrev.toUpperCase() : null,
              countryName: countryName,
              countryWithin: lodashGet(data, "properties.countryWithin")
                ? data.properties.countryWithin
                : null,
              countryCode: countryCode,
              bounds:
                data && data.geometry
                  ? getBoundsStringFromGeometrySWNE(data.geometry)
                  : null,
              dosInfoUrl:
                data && data.properties && data.properties.dosInfoUrl
                  ? data.properties.dosInfoUrl
                  : null,
            },
          };

          this.$set(this.collections, "eventsFeatures", null);
          this.getContentEvents(null, null, true);
          this.incidentsRefresh = new Date().toISOString();

          if (this.hasWebGL) {
            await this.getStabilitySourceFromTile();
          }
          await this.getStability();

          if (this.watchEnabled || !notFromDropdown) {
            this.getHistogramStability();
            this.getSentiment();
            this.getHotspots();
            this.getTravel = new Date().toISOString();
            // this.getAlertsTriggered();
            this.getAlertedContent();
            this.mapAll();
            this.savePrefs(location.stabilityType, location._id);
            this.changeUrl();
          }
        }
      }
    },
    openAlertedContent(alert) {
      if (this.isStandalone) {
        this.selectorPanel.selected = "alerts";
        this.selectorPanel.selectedData = {};
        this.selectorPanel.selectedData.alertId = alert.alertId
          ? alert.alertId
          : null;
        this.selectorPanel.selectedData.triggeredId = alert.triggeredId
          ? alert.triggeredId
          : null;
        this.selectorPanel.visible = true;
        this.$store.dispatch(
          MODULE_PREFIX_HOME + GET_SELECTOR_PANEL,
          this.selectorPanel
        );
      }
    },
    getDateFormatted(date) {
      if (date) {
        return getFormatted(date);
      }
      return null;
    },
    onMapLoadFnc() {
      this.mapLoaded = true;
      this.mapAll();
    },
    mapOnMoveEnd() {
      this.getStabilitySourceFromTile();
      this.getForecastStabilitySourceFromTile();
    },
    onMapIdleFnc() {
      this.getStabilitySourceFromTile();
      this.getForecastStabilitySourceFromTile();
    },
    mapAll() {
      if (this.isMapAvailable() && this.mapLoaded) {
        this.mapPulseRegion();
        this.mapPulseCountry();
        this.mapPulseCity();
        this.mapPulseCounty();
        this.mapForecastPulseRegion();
        this.mapForecastPulseCountry();
        this.mapForecastPulseCity();
        this.mapForecastPulseCounty();
        this.centerMap();
        this.mapHotspots();
        this.map.resize();
      }
    },
    isMapAvailable() {
      if (
        this.hasWebGL &&
        typeof this.map !== "undefined" &&
        this.map &&
        typeof this.map.getStyle() !== "undefined"
      ) {
        return true;
      }
      return false;
    },
    removeLayer(layerId) {
      if (this.isMapAvailable()) {
        const LAYERS = this.map.getStyle().layers;
        const LEN = LAYERS.length;
        let layer;
        let exists = false;
        for (let i = 0; i < LEN; i++) {
          layer = LAYERS[i];
          if (layer.id === layerId) {
            exists = true;
            break;
          }
        }
        if (exists) {
          removeMapData(this.map, layerId);
        }
      }
    },
    clearMap() {
      if (this.isMapAvailable()) {
        this.removeLayer(`layer-pulse-${GRIDS_STABILITY_TYPES.region}`);
        this.removeLayer(`layer-pulse-${GRIDS_STABILITY_TYPES.country}`);
        this.removeLayer(`layer-pulse-${GRIDS_STABILITY_TYPES.city}`);
        this.removeLayer(
          `layer-forecast-pulse-${GRIDS_STABILITY_TYPES.region}`
        );
        this.removeLayer(
          `layer-forecast-pulse-${GRIDS_STABILITY_TYPES.country}`
        );
        this.removeLayer(`layer-forecast-pulse-${GRIDS_STABILITY_TYPES.city}`);
        this.removeLayer(this.layerIdAoi + "-polygon");
        this.removeLayer(this.layerIdHotspots);
        this.removeLayer(this.layerIdHotspots + "-marker");
      }
    },
    async centerMap() {
      if (this.isMapAvailable()) {
        this.removeLayer(this.layerIdAoi + "-polygon");
        if (lodashGet(this.aoi, "geometry.coordinates")) {
          const FEATURES = [this.aoi];
          const BBOX = getBboxFromFeatures(FEATURES);
          this.map.fitBounds(BBOX, { padding: 20 });
        }
      }
    },
    mapPulseRegion() {
      this.mapPulse(GRIDS_STABILITY_TYPES.region);
    },
    mapPulseCountry() {
      this.mapPulse(GRIDS_STABILITY_TYPES.country);
    },
    mapPulseCity() {
      this.mapPulse(GRIDS_STABILITY_TYPES.city);
    },
    mapPulseCounty() {
      this.mapPulse(GRIDS_STABILITY_TYPES.county);
    },
    mapPulse(type) {
      if (this.isMapAvailable()) {
        this.removeLayer(`layer-pulse-${type}`);
        const PARAMS = {
          id: `pulse`,
          type: type,
          sourceId: `source-pulse-${type}`,
          layerId: `layer-pulse-${type}`,
          map: this.map,
          opacity: 0.01,
        };
        if (
          this.aoi &&
          this.aoi.properties &&
          this.aoi.properties.code &&
          this.aoi.properties.stabilityType
        ) {
          PARAMS.aoiCode = this.aoi.properties.code;
          if (
            this.aoi.properties.stabilityType === GRIDS_STABILITY_TYPES.country
          ) {
            PARAMS.aoiCode = PARAMS.aoiCode.toUpperCase();
          }
          PARAMS.aoiCodeField = "_id";
        }
        addPulseToMap(PARAMS);
      }
    },
    mapForecastPulseRegion() {
      this.mapForecastPulse(GRIDS_STABILITY_TYPES.region);
    },
    mapForecastPulseCountry() {
      this.mapForecastPulse(GRIDS_STABILITY_TYPES.country);
    },
    mapForecastPulseCity() {
      this.mapForecastPulse(GRIDS_STABILITY_TYPES.city);
    },
    mapForecastPulseCounty() {
      this.mapForecastPulse(GRIDS_STABILITY_TYPES.county);
    },
    mapForecastPulse(type) {
      if (this.isMapAvailable()) {
        this.removeLayer(`layer-forecast-pulse-${type}`);
        const FORECAST_PARAMS = {
          id: `pulse`,
          type: type,
          sourceId: `source-forecast-pulse-${type}`,
          layerId: `layer-forecast-pulse-${type}`,
          map: this.map,
          opacity: 0.01,
        };
        addPulseForecastToMap(FORECAST_PARAMS);
      }
    },
    mapHotspots() {
      if (this.aoi && this.isMapAvailable()) {
        this.removeLayer(this.layerIdHotspots);
        this.removeLayer(this.layerIdHotspots + "-marker");
        let params = {
          id: "hotspots" + this._uid,
          layerId: this.layerIdHotspots,
          map: this.map,
          mapClickEvent: this.mapHotspotClickEvent,
          filters: ["positive"],
          start: this.dateStart,
          end: this.dateEnd,
          noCluster: true,
          iconColor: "red",
          iconName: MAP_ICON_NAMES.hotspots,
        };
        if (
          this.aoi.properties.stabilityType === GRIDS_STABILITY_TYPES.region
        ) {
          params.bounds = this.aoi.properties.bounds;
        } else {
          params.aoiId = this.aoi.properties.code;
        }
        addHotspotsToMap(params);

        if (this.hotspotFeatures) {
          this.addHotspotSelectedLayer();
        }
      }
    },
    isHotspotSelected(check) {
      const checkClusterIds =
        typeof check.properties.clusterIds === "object"
          ? JSON.stringify(check.properties.clusterIds)
          : check.properties.clusterIds;

      let isSelected = false;
      if (
        this.hotspotFeatures &&
        this.hotspotFeatures.filter((hotspotFeature) => {
          const clusterIds =
            typeof hotspotFeature.properties.clusterIds === "object"
              ? JSON.stringify(hotspotFeature.properties.clusterIds)
              : hotspotFeature.properties.clusterIds;
          return clusterIds === checkClusterIds;
        }).length > 0
      ) {
        isSelected = true;
      }
      return isSelected;
    },
    mapHotspotClickEvent(e, features) {
      if (e) {
        e.originalEvent.stopPropagation();
      }

      let shouldToggleOff = false;
      features.forEach((feature) => {
        if (this.isHotspotSelected(feature)) {
          shouldToggleOff = true;
        }
      });

      if (shouldToggleOff) {
        this.handleHotspotMapClearClick();
      }

      if (features.length > 0) {
        if (
          lodashGet(features[0], "properties.geohash") &&
          lodashGet(features[0], "properties.topics")
        ) {
          this.hotspotFeatures = features;
          this.addHotspotSelectedLayer();
          this.hotspotGeohash = features[0].properties.geohash;
          const HOTSPOT_TOPICS =
            typeof features[0].properties.topics === "string"
              ? JSON.parse(features[0].properties.topics)
              : features[0].properties.topics;
          this.hotspotTopics = HOTSPOT_TOPICS.map((topic) => {
            return getTopicKey(topic, false);
          });
          this.getContentEvents();
          this.getSentiment();
        }
      }
    },
    addHotspotSelectedLayer() {
      this.removeHotspotSelectedLayer();
      this.map.addSource(this.hotspotSelectedId, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: this.hotspotFeatures,
        },
      });
      this.map.addLayer({
        id: this.hotspotSelectedId,
        type: "symbol",
        source: this.hotspotSelectedId,
        layout: {
          "icon-image": MAP_ICON_NAMES.hotspotsSelected,
          "icon-size": 0.7,
        },
      });
    },
    removeHotspotSelectedLayer() {
      if (this.map) {
        if (this.map.getLayer(this.hotspotSelectedId)) {
          this.map.removeLayer(this.hotspotSelectedId);
        }
        if (this.map.getSource(this.hotspotSelectedId)) {
          this.map.removeSource(this.hotspotSelectedId);
        }
      }
    },
    getIconSrc(type) {
      if (type === "pulse") {
        return require(`@/assets/images/icons/pulse_orange_big.png`);
      } else if (type === "events") {
        return require(`@/assets/images/icons/events_big.png`);
      } else if (type === "travel") {
        return require(`@/assets/images/icons/travel_big.png`);
      } else if (type === "hotspots") {
        return require(`@/assets/images/icons/hotspots_big.png`);
      } else if (type === "alerts") {
        return require(`@/assets/images/icons/alerts_big.png`);
      }
      return require(`@/assets/images/icons/earthquake.png`);
    },
    handleResize: lodashDebounce(function () {
      if (
        this.appHeight !== window.innerHeight ||
        this.appWidth !== window.innerWidth
      ) {
        this.chartRefresh = new Date().toISOString();
        this.chartSentimentRefresh = new Date().toISOString();
        this.refresh();
        this.appHeight = window.innerHeight;
        this.appWidth = window.innerWidth;
        this.$set(this.collections, "eventsFeatures", null);
      }
    }, 2000),
    gridChartClickHandler(params) {
      this.handleHotspotMapClearClick();
      if (params && params.date) {
        this.startDateOverride = dayjs.utc(params.date).startOf("day");
        this.endDateOverride = dayjs.utc(params.date).endOf("day");
        this.refresh();
      } else if (params && params.reset) {
        this.startDateOverride = null;
        this.endDateOverride = null;
        this.hotspotFeatures = null;
        this.hotspotGeohash = null;
        this.hotspotTopics = null;
        this.refresh();
      }
    },
    timeRangeChange(params) {
      this.timeRange = params.val;
      this.timeRangeDisplay = params.display;
      if (!this.isControlRisksRatings || this.source !== "incidents") {
        this.getContentEvents(null, null, true);
      }
    },
    addGeoToParams(params) {
      if (this.aoi) {
        if (
          this.aoi.properties.stabilityType === GRIDS_STABILITY_TYPES.region
        ) {
          params.bounds = this.aoi.properties.bounds;
        } else {
          params.aoiId = this.aoi.properties.code;
        }
      }

      if (
        this.isControlRisksRatings &&
        lodashGet(this.riskRatingsCountry, "iso2Code")
      ) {
        params.aoiId = this.riskRatingsCountry.iso2Code;
      }

      if (
        this.hotspotGeohash ||
        this.detailsSidebar.monitorType.indexOf(DETAIL_SIDEBAR_TYPES.hotspots) >
          -1
      ) {
        let geohash = this.hotspotGeohash;
        if (
          this.features &&
          Array.isArray(this.features) &&
          this.features.length > 0 &&
          lodashGet(this.features[0], "properties.geohash")
        ) {
          geohash = this.features[0].properties.geohash;
        }
        if (geohash) {
          const FEATURE = getGeohashFeature(geohash);
          let bounds = getBoundsStringFromGeometrySWNE(FEATURE.geometry);
          params.bounds = bounds;
        }
      }
      return params;
    },
    addStartEndToParams(params) {
      const START = dayjs(this.dateEnd).format("YYYY-MM-DD");
      const MINUS_NINETY = dayjs(START)
        .subtract(60, "days")
        .format("YYYY-MM-DD");

      params.start = `${MINUS_NINETY}T00:00:00.000Z`;

      params.end = this.dateEnd;

      if (this.timeRange && !this.enabled) {
        let altStart = dayjs
          .utc()
          .subtract(this.timeRange, "days")
          .toISOString();
        params.start = altStart;
      }
      if (this.hotspotGeohash) {
        const DATE_PARTS = this.dateStart.split("T");
        const PLUS_ONE = dayjs(DATE_PARTS[0])
          .add(1, "days")
          .format("YYYY-MM-DD");
        params.end = `${PLUS_ONE}T23:59:59.999Z`;
        params.start = this.dateStart;
      }
      return params;
    },
    getEventTypesToGrab() {
      if (
        this.detailsSidebar.monitorType.indexOf(DETAIL_SIDEBAR_TYPES.hotspots) >
          -1 ||
        !this.eventTypesTotals
      ) {
        return this.eventTypesSelected;
      }

      let eventTypesToGrab = [];
      if (this.eventTypesSelected && this.eventTypesTotals) {
        for (let i = 0; i < this.eventTypesSelected.length; i++) {
          if (this.eventTypesTotals[this.eventTypesSelected[i]] !== 0) {
            eventTypesToGrab.push(this.eventTypesSelected[i]);
          }
        }
      }
      return eventTypesToGrab;
    },
    handleHotspotMapClearClick(ignoreDataRefresh) {
      this.clearSelectedHotspot();
      this.getContentEvents();
      this.getSentiment();
    },
    clearSelectedHotspot() {
      this.hotspotFeatures = null;
      this.hotspotGeohash = null;
      this.hotspotTopics = null;
      this.removeHotspotSelectedLayer();
    },
    getAlertName(sourceAlertId) {
      let alert;
      if (this.alerts) {
        alert = lodashFind(this.alerts, (alert) => {
          if (alert.id === sourceAlertId) {
            return alert;
          }
        });
      }
      return alert.name ? alert.name : null;
    },
    addAlertIdsFilter(params) {
      if (this.collections.alertFilters) {
        let alertIds = [];
        let keys = Object.keys(this.collections.alertFilters);
        keys.forEach((key) => {
          alertIds.push(this.collections.alertFilters[key].id);
        });
        params.alertsIdFilter = alertIds;
      }
      return params;
    },
    contentFilterCallback(obj) {
      this.collections[obj.field] = obj.data;
      this.getAlertedContent();
    },
    addVeracityFilter(params) {
      if (this.collections.veracityFilters) {
        let veracities = [];
        let keys = Object.keys(this.collections.veracityFilters);
        keys.forEach((key) => {
          veracities.push(this.collections.veracityFilters[key].name);
        });
        params.veracityFilter = veracities;
      }
      return params;
    },
    getThresholdTypeFunction(doc) {
      let thresholdType = "cluster";
      if (
        lodashGet(doc, "properties.formatted.source") === "twitter.com" ||
        lodashGet(doc, "properties.formatted.source") === "twitter"
      ) {
        thresholdType = "twitter";
      }
      return thresholdType;
    },
    handleCopyClick() {
      this.handlePageTrackerEvent(
        EVENT_CATEGORIES.monitor,
        EVENT_ACTIONS.clicked,
        " Screenshot " + this.locationName + " Dashboard"
      );

      document.activeElement.blur();

      this.screenShotting = true;

      html2canvas(document.querySelector(".hyp-details-sidebar-container"), {
        useCORS: true,
      }).then((canvas) => {
        try {
          const linkSource = canvas.toDataURL("image/png");
          const downloadLink = document.createElement("a");
          const fileName = "screenshot_" + this.locationName + ".jpg";

          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          this.screenShotting = false;
        } catch (e) {
          console.log(e);
        }
      });
    },
    async handleGetCountryReport() {
      this.handlePageTrackerEvent(
        EVENT_CATEGORIES.monitor,
        EVENT_ACTIONS.clicked,
        " Country Report " + this.locationName
      );
      let requestTimestamp = new Date().toISOString();
      // Report Generating endpoint expects uppercase iso2 code
      let countryIso2Code = this.locationInfo.code.toUpperCase();
      this.isCountryReportLoading = true;
      await getCountryReport(
        { countryCode: countryIso2Code },
        requestTimestamp
      );
      this.isCountryReportLoading = false;
    },
    handleChartSelection: async function (value) {
      this.chartTypeSelection = value;
      // this.refresh(); //call refresh() so the pulse chart is drawn
      // update: this is the code nested in refresh() that does the trick.
      // TODO I don't know why.
      if (this.map) {
        this.map.resize();
      }
    },
  },
  beforeDestroy() {
    this.initialLoad = true;
    this.mapLoaded = false;
    this.aoi = null;
    this.locationPrevious = null;
    this.pulseChartLoading = false;
    this.hotspotsLoading = false;
    this.alertsLoading = false;
    this.sentimentLoading = false;
    this.eventsLoading = false;
    this.eventsPage = 1;
    this.eventsSearch = null;
    this.eventTypes = null;
    this.eventTypesSelected = null;
    this.histogramStability = null;
    this.getTravel = null;
    this.idsPulled = [];
    this.lastTimestamp = null;
    this.collections = {
      hotspots: null,
      alerts: null,
      alertedContent: null,
      alertedContentTotal: null,
      charts: {
        emotionChartData: {},
      },
      travel: null,
      stabilitySourceFromTile: null,
      forecastStabilitySourceFromTile: null,
      sentiment: null,
      eventsTotal: null,
      eventsTotals: null,
      eventsFeatures: null,
    };

    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }

    this.$store.commit(MODULE_PREFIX_MONITOR + SET_MONITOR_STABILITY, {
      Item: null,
    });
    this.$store.dispatch(MODULE_PREFIX_MONITOR + GET_MONITOR_ENABLED, false);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    this.$store.dispatch(MODULE_PREFIX_HOME + GET_AUTO_REFRESH_ENABLED, true);
  },
  watch: {
    searchDetails: {
      async handler() {
        if (this.searchType === "monitor") {
          if (this.localSearchDetails === this.searchDetails) {
            return;
          }
          this.localSearchDetails = this.searchDetails;
          this.topicsFilterClick(this.eventTypesSelected, false);
        }
      },
    },
  },
};
</script>

<style>
.theme--dark.v-sheet {
  background-color: #191a1a !important;
  border-color: #191a1a !important;
}
</style>
<style scoped>
.hyp-event-heading {
  font-size: 17px;
}
.hyp-section-title {
  padding: 10px 0 0 10px;
  font-size: 16px;
}
.hyp-date {
  font-size: 10px;
}
.hyp-hotspots-container {
  height: 180px;
  font-size: 14px;
  overflow-y: auto;
}
.hyp-alerts-container {
  height: 180px;
  overflow-y: auto;
}
.hyp-forecast-container {
  background-color: transparent !important;
  border-color: transparent !important;
}
.hyp-close-watch-container {
  background-color: transparent !important;
  border-color: transparent !important;
}
.hyp-close-watch-btn {
  position: relative;
  min-width: 10px;
  background-color: transparent !important;
  color: white !important;
}
.aoiTimePart {
  padding-left: 10px;
  padding-bottom: 10px;
  position: relative;
  top: 7px;
  font-size: 24px;
}
.hyp-no-data-text {
  color: gray !important;
}
.hyp-icon-img {
  height: 20px;
  width: 20px;
}
.hyp-item-container {
  width: 85%;
  word-wrap: break-word;
}
.hyp-alert-item {
  cursor: pointer;
}
.hotspot-icon {
  cursor: pointer;
}
.hyp-details-source-selector {
  margin-top: 10px;
  margin-right: 8px;
}
.hyp-hotspot-map-clear-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
}
.hyp-alert-content-filter-container {
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 0px;
}
/* These are for the scroll bar in the content container */
::-webkit-scrollbar {
  width: 8px;
  height: 3px;
}
::-webkit-scrollbar-track {
  background-color: #646464;
  border-radius: 3px;
}
::-webkit-scrollbar-track-piece {
  background-color: #000;
}
::-webkit-scrollbar-thumb {
  height: 50px;
  background-color: #666;
  border-radius: 3px;
}
.map_holder {
  width: 100%;
}
.container-relative {
  position: relative;
}

.close_container {
  padding-left: 10px;
  padding-bottom: 10px;
  position: relative;
  top: 7px;
  font-size: 24px;
}

.v-overlay {
  left: 0px !important;
  background-color: rgba(0, 0, 0, 0) !important;
}

.v-overlay--active.v-overlay {
  background-color: rgba(0, 0, 0, 0.75) !important;
}

.copy-overlay-indicator {
  width: 120px;
  height: 120px;
  background-color: green;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  font-size: large;
}
</style>
